export default [
  {
    path: '/purchase/:id',
    name: 'purchase',
    component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/Purchases/Purchase'),
    reverse: 'purchases-single',
    meta: { permission: 'api.view_purchase' }
  },
  {
    path: '/purchase-list',
    component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/Purchases/PurchaseParent'),
    children: [
      {
        path: '',
        name: 'purchase-list',
        component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/Purchases/PurchaseList'),
        meta: { permission: 'api.view_purchase' }
      },
      {
        path: '/create-purchase',
        name: 'create-purchase',
        component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/Purchases/CreatePurchase'),
        meta: { permission: 'api.add_purchase' }
      }
      // {
      //   path: '/price-quote',
      //   name: 'price-quote',
      //   component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/PriceQuote/PriceQuote'),
      //   meta: { permission: 'api.view_purchase' }
      // }
    ]
  },

  {
    path: '/checkin-list/',
    name: 'checkin-list',
    component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/CheckIns/CheckInList'),
    meta: { permission: 'api.view_checkin' }
  },
  {
    path: '/checkin/:id/edit',
    name: 'edit-checkin',
    component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/CheckIns/Edit/EditCheckIn'),
    props: true,
    meta: { permission: 'api.change_checkin' }
  },
  {
    path: '/checkin/:id/wrap-up',
    name: 'complete-checkin',
    component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/CheckIns/Complete/CompleteCheckIn'),
    props: true,
    meta: { permission: 'api.change_checkin' }
  },
  {
    path: '/checkin/:id/payment',
    name: 'payment-checkin',
    component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/CheckIns/Payment/CheckInPayment'),
    props: true,
    meta: { permission: 'api.add_checkinpayment' }
  },
  {
    path: '/checkin/:id/modify',
    name: 'check-in-modify',
    component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/CheckIns/CheckInModify'),
    meta: { permission: 'api.change_checkin' }
  },
  {
    path: '/checkin/:id/split',
    name: 'check-in-split',
    component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/CheckIns/CheckInSplit.vue'),
    meta: { permission: 'api.add_checkin' }
  },
  {
    path: '/checkin/:id',
    name: 'check-in',
    component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/CheckIns/CheckIn'),
    reverse: 'check_ins-single',
    meta: { permission: 'api.view_checkin' }
  },
  {
    path: '/reports/check-in/dump',
    name: 'check-in-dump-report',
    component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/Reports/CheckInDumpReport'),
    meta: { permission: 'api.view_checkin_dump_report' }
  },
  {
    path: '/reports/cat-check-in',
    name: 'cat-check-in-report',
    component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/Reports/CatCheckInReport'),
    meta: { permission: 'frontend.view_cat_checkin_report' }
  },
  // {
  //   path: '/intake/create-using-boxes',
  //   name: 'create-intake-using-boxes',
  //   component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/Intakes/CreateIntakeUsingBoxes'),
  //   meta: { permission: 'api.add_intake' }
  // },
  {
    path: '/intake/create',
    name: 'create-intake',
    component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/Intakes/CreateIntake'),
    meta: {
      permission: 'api.add_intake',
      redirect: '/site/intakes/create/'
    }
  },
  {
    path: '/intake/:id',
    name: 'intake',
    component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/Intakes/Intake'),
    reverse: 'intakes-single',
    meta: {
      permission: 'api.view_intake',
      redirect: '/site/intakes/{id}/'
    }
  },
  {
    path: '/intake',
    name: 'intake-list',
    component: () => import(/* webpackChunkName: "purchase-routes" */ '@/views/Intakes/IntakeList'),
    meta: {
      permission: 'api.view_intake',
      redirect: '/site/intakes/'
    }
  },
  {
    path: '/identify-token/:id',
    name: 'identify-token',
    component: () => import(/* webpackChunkName: "identify-token" */ '@/views/IdentifierToken/IdentifierTokenView.vue')
  }
]
